module.exports = __webpack_public_path__ + "static/turnero_offline-47755c62b7fd4470c9f86be3d639ee08.png";